module.exports = __webpack_public_path__ + "static/media/avatar.52f20fcc.png";